import { PostAssignee } from 'api';

export const getAssigneeInitials = (assignee?: PostAssignee) =>
  assignee?.first_name && assignee?.last_name
    ? `${assignee.first_name[0]}${assignee.last_name[0]}`.toUpperCase()
    : '';
